import {
  ShowProps,
  SimpleShowLayout,
  TextField,
  SelectField,
  DateField,
  BooleanField,
  RichTextField,
  ReferenceField,
} from "react-admin";
import { DefaultShow, UploadedFilesField } from "../../../lib/components";
import { COMMON_DATE_TIME_FORMAT } from "../../../lib/core";
import { CATEGORY_TYPE_CHOICES, RESOURCE_NAME_CATEGORY } from "./constants";

const CategoryShow= (props:ShowProps) => {
  return (
    <DefaultShow {...props}>
      <SimpleShowLayout>
        <TextField source="number" />
        <TextField source="name" />
        <RichTextField source="description" />
        <SelectField source="categoryType" choices={CATEGORY_TYPE_CHOICES} />
        <ReferenceField source="parentId" reference={RESOURCE_NAME_CATEGORY}>
          <TextField source="displayLabel" />
        </ReferenceField>
        <DateField source="createdAt" options={COMMON_DATE_TIME_FORMAT} />
        <DateField source="updatedAt" options={COMMON_DATE_TIME_FORMAT} />
        <TextField source="version" />
        <BooleanField source="isActive" />
        <UploadedFilesField canDelete={false} />
      </SimpleShowLayout>
    </DefaultShow>
  );
};

export { CategoryShow };
